var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dialogVisible)?_c('div',{staticClass:"inner-frame"},[_c('div',{staticClass:"inner-frame-container"},[_c('i',{staticClass:"el-icon-close inner-frame-close",on:{"click":_vm.close}}),_vm._v(" "),_c('iframe',{attrs:{"src":_vm.src,"frameborder":"0"}})])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a065f56a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/innerFrame.vue
// module id = YchB
// module chunks = 1